import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
export const BuildingState = ({
  values,
  handleChangeCaracObj,
  errors,
  touched
}) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'Excelente' },
    { value: 2, label: 'Muy Bueno' },
    { value: 3, label: 'Bueno' },
    { value: 4, label: 'A Refaccionar' },
    { value: 5, label: 'Reciclado' },
    { value: 6, label: 'Regular' }
  ];
  return (
    <div>
      <label>Estado de la propiedad</label>
      <ReactSelect
        name="buildingState"
        placeholder="-- Seleccione el estado --"
        options={options}
        value={options.find(v => v.value === values)}
        onChange={e => {
          handleChangeCaracObj('buildingState', e?.value && Number(e.value));
        }}
      />
      {errors?.type && touched?.type && (
        <label className="w-100 text-danger">{errors.type}</label>
      )}
    </div>
  );
};

BuildingState.propTypes = {
  values: PropTypes.object,
  handleChangeCaracObj: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
